// extracted by mini-css-extract-plugin
module.exports = {"container":"container_3B2np","button":"button_1QC7F","header":"header_2TCtq","timer":"timer_-FEGW"};